import { render, staticRenderFns } from "./RepairAccountDetail.vue?vue&type=template&id=624e94cc&scoped=true&"
import script from "./RepairAccountDetail.vue?vue&type=script&lang=js&"
export * from "./RepairAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./RepairAccountDetail.vue?vue&type=style&index=0&id=624e94cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e94cc",
  null
  
)

export default component.exports